/**
 * ## Header Controller
 *
 * @module src/controllers/header
 */

"use strict";

const schedule = require("node-schedule");
const component = require("../../components/component");
const notification = require("../../components/notification");
const chart = require("../../components/chart");
const conf = require("../../config");
const moment = require("moment-timezone");
const xss = require("xss");
const modal = require("../../components/modal");
const demo = require("../../controllers/demo");
const l = require("../../common").localization;

const setBlocker = (bool) => {
  if (bool) {
    $("#temp_editor_top").css("display", "block");
    $("#temp_editor_sidebar").css("display", "block");
    $("#temp_editor_template").css("display", "block");
  } else {
    $("#temp_editor_top").css("display", "none");
    $("#temp_editor_sidebar").css("display", "none");
    $("#temp_editor_template").css("display", "none");
  }
};

const init = (kd) => {
  kd.localstore.data.filter = {
    name: "",
    time: 0,
    note: "",
    preference: "",
  };

  $("#search_box").on("keyup", () => {
    kd.localstore.data.filter.name = $("#search_box").val();
    $("#reservation_filter_search").val($("#search_box").val());
    kd.emit("block.update", {});
  });

  schedule.scheduleJob("* * * * *", () => {
    setTimeHeader();
  });

  setTimeHeader();

  const configdrop = [
    {
      description: l.translate("Guest List Dashboard"),
      value: "dashboard",
    },
    {
      description: l.translate("Device Settings"),
      value: "settings",
    },
    {
      description: l.translate("Seat Map Options"),
      value: "seatmap",
    },
    {
      description: l.translate("Log Out"),
      value: "logout",
    },
  ];

  if (conf.vars.ui === "reservation") {
    configdrop.splice(2, 1);
  }

  let touchCount = 0;

  $("#layout_chart_header_daily").fastClick((e) => {
    ++touchCount;
    if (touchCount === 11) {
      demo.start(kd);
    }
  });

  $("#layout_chart_aux, #layout_chart_header_menu").fastClick((e) => {
    const options = {
      target_id: "layout_chart_aux",
      type: "dropdown",
      position: "bottom",
      highlight: null,
      adjust: {
        x: 0,
        y: -10,
      },
    };
    component.create(options, configdrop, (err, value) => {
      switch (value.value) {
        case "dashboard": {
          let host = window.location.href.replace(
            "guestlist",
            "guestlistdashboard"
          );
          if (host.indexOf("/#") > -1) {
            host = `${host.split("/#")[0]}`;
          }
          if (conf.vars.NODE_ENV.indexOf("ios") > -1) {
            window.open("https://guestlistdashboard.heartland.us", "_system");
          } else if (conf.vars.NODE_ENV.indexOf("android") > -1) {
            navigator.app.loadUrl("https://guestlistdashboard.heartland.us", {
              openExternal: true,
            });
          } else {
            window.open(host, "_blank");
          }
          break;
        }
        case "settings": {
          const opt = {
            width: "80%",
            type: "settings",
            h1: l.translate("Settings For This Device"),
            body: l.translate(
              "Below you will find settings that apply to only this " +
                "device. Changes here will not be represented in other devices logged " +
                "into the same account."
            ),
            fields: [
              {
                description: l.translate("Limit Rule Set Name"),
              },
            ],
            buttons: [
              {
                description: l.translate("Close"),
                value: "close",
              },
            ],
          };
          const data = {
            kd,
          };
          modal.create(opt, data, (err6) => {
            modal.destroy();
          });
          break;
        }
        case "seatmap": {
          const location = kd.find("location")[0];
          const seatmapdrop = [
            {
              description: l.translate("Change Seat Map"),
              value: "change",
            },
            {
              description: l.translate("Move Tables Temporarily"),
              value: "move",
            },
          ];
          const options2 = {
            target_id: "layout_chart_aux",
            type: "dropdown",
            position: "bottom",
            highlight: null,
            adjust: {
              x: 0,
              y: -10,
            },
          };
          component.create(options2, seatmapdrop, (err2, val) => {
            switch (val.value) {
              case "change": {
                const chartObj = [];
                const charts = Object.assign(
                  [],
                  kd.find("chart", { active: 1 })
                ).reverse();
                for (let i = 0; i < charts.length; ++i) {
                  if (!charts[i].hasOwnProperty("name")) {
                    charts[i].name = `${l.translate("Seat Map")} ${i + 1}`;
                  }
                  chartObj.push({
                    description: charts[i].name,
                    value: charts[i]._id,
                  });
                }
                let mapname = kd.doc("chart", location.chart)[0].name;
                if (!mapname) {
                  mapname = `${l.translate("Seat Map")} 1`;
                }
                const options3 = {
                  target_id: "layout_chart_aux",
                  type: "dropdown",
                  position: "bottom",
                  highlight: mapname,
                  adjust: {
                    x: 0,
                    y: -10,
                  },
                };
                component.create(options3, chartObj, (err5, val5) => {
                  const opt = {
                    position: "top",
                    width: "90%",
                    seconds: 0,
                    h1: l.translate("Change to this seat map?"),
                    body: l.translate(
                      "This will be applied to all connected " +
                        "devices. Any guests seated at tables that do not exist in " +
                        "another map will not be visible."
                    ),
                    buttons: [
                      {
                        description: l.translate("Cancel"),
                        value: "cancel",
                      },
                      {
                        description: l.translate("Proceed"),
                        value: "proceed",
                      },
                    ],
                  };
                  notification.create(opt, {}, (err7, value2) => {
                    if (!err7 && value2 === "proceed") {
                      const proposed = {
                        domain: "location",
                        _id: location._id,
                        chart: val5.value,
                      };
                      kd.update(proposed)
                        .then((result) => {
                          const new_id = kd.find("template", {
                            chart: val5.value,
                          })[0]._id;
                          const proposed2 = {
                            domain: "location",
                            _id: location._id,
                            template: new_id,
                          };
                          return kd.update(proposed2);
                        })
                        .then((result) => {
                          kd.chartdata = kd.doc("chart", val5.value)[0];
                          kd.emit("chart.update", {});
                        })
                        .catch((err3) => {
                          console.log("err3", err3);
                        });
                    }
                    notification.destroy();
                  });
                });
                break;
              }
              case "move": {
                const opt = {
                  position: "top",
                  width: "90%",
                  seconds: 0,
                  h1: l.translate("Adjust Table Locations"),
                  body: l.translate(
                    "This mode allows you to temporarily move table " +
                      "locations. Any changes made here can be reset to the original " +
                      "layout at any time. To be done moving tables, select the `Done` " +
                      "option in the lower left hand corner."
                  ),
                  buttons: [
                    {
                      description: l.translate("Continue"),
                      value: "confirm",
                    },
                    {
                      description: l.translate("Cancel"),
                      value: "cancel",
                    },
                  ],
                };
                notification.create(opt, {}, (err7, value2) => {
                  notification.destroy();
                  if (value2 === "confirm") {
                    setBlocker(true);
                    conf.vars.localAltTables = "tables";
                    kd.localstore.data.op_state = "inline";
                    chart.disable();
                    $("#layout_alt_tables").css("visibility", "visible");
                    kd.emit("chart.update", {});
                  }
                });
                break;
              }
              case "revert": {
                const opt = {
                  position: "top",
                  width: "90%",
                  seconds: 0,
                  h1: l.translate("Are you sure you want to revert?"),
                  body: l.translate(
                    "Doing this will revert your adjustments back " +
                      "to their original positions."
                  ),
                  buttons: [
                    {
                      description: "Cancel",
                      value: "cancel",
                    },
                    {
                      description: "Yes, revert",
                      value: "revert",
                    },
                  ],
                };
                notification.create(opt, {}, (err7, value2) => {
                  notification.destroy();
                  if (value2 === "revert") {
                    conf.vars.localAltTables = "none";
                    kd.localstore.data.op_state = "standard";
                    chart.enable();
                    const proposed = {
                      domain: "location",
                      _id: location._id,
                      altTables: false,
                    };
                    kd.update(proposed)
                      .then((result) => {
                        kd.emit("chart.update", {});
                      })
                      .catch((err3) => {
                        console.log("err3", err3);
                      });
                  }
                });
                break;
              }
              default: {
                break;
              }
            }
          });
          break;
        }
        case "language": {
          const options2 = {
            target_id: "layout_chart_aux",
            type: "dropdown",
            position: "bottom",
            highlight: null,
            adjust: {
              x: 0,
              y: -10,
            },
          };
          component.create(options2, conf.vars.languages, (err2, val) => {
            window.localStorage.setItem("language", val.value);
            let loc = xss(window.location.href).split("?")[0];
            if (loc.indexOf("/#") > -1) {
              loc = `${loc.split("/#")[0]}/`;
            }
            window.location = `${loc}?usage=resume&jwt=${conf.vars.userdata.jwtToken}\
&site_id=${conf.vars.userdata.site_id}`;
          });
          break;
        }
        case "logout": {
          window.localStorage.setItem("lastLogin", 0);
          window.location = xss(window.location.href).split("?")[0];
          break;
        }
        default: {
          break;
        }
      }
    });
  });
};

const setTimeHeader = () => {
  $("#layout_chart_header_h2").html(
    moment().format(l.translate("h:mm a, MMM D"))
  );
};

module.exports = {
  init,
  setBlocker,
};



/** WEBPACK FOOTER **
 ** ./src/controllers/header/index.js
 **/